// Generated by purs version 0.15.15
import * as Foreign_Generic_Class from "../Foreign.Generic.Class/index.js";
import * as Restaumatic_Analytics_Types_BeginCheckout from "../Restaumatic.Analytics.Types.BeginCheckout/index.js";
import * as Restaumatic_Analytics_Types_ChooseAddress from "../Restaumatic.Analytics.Types.ChooseAddress/index.js";
import * as Restaumatic_Analytics_Types_ChooseDate from "../Restaumatic.Analytics.Types.ChooseDate/index.js";
import * as Restaumatic_Analytics_Types_ChooseDelivery from "../Restaumatic.Analytics.Types.ChooseDelivery/index.js";
import * as Restaumatic_Analytics_Types_ChooseDineIn from "../Restaumatic.Analytics.Types.ChooseDineIn/index.js";
import * as Restaumatic_Analytics_Types_ChooseTakeaway from "../Restaumatic.Analytics.Types.ChooseTakeaway/index.js";
import * as Restaumatic_Analytics_Types_Event from "../Restaumatic.Analytics.Types.Event/index.js";
import * as Restaumatic_Analytics_Types_ExperienceImpression from "../Restaumatic.Analytics.Types.ExperienceImpression/index.js";
import * as Restaumatic_Analytics_Types_FindAddress from "../Restaumatic.Analytics.Types.FindAddress/index.js";
import * as Restaumatic_Analytics_Types_Item from "../Restaumatic.Analytics.Types.Item/index.js";
import * as Restaumatic_Analytics_Types_ItemList from "../Restaumatic.Analytics.Types.ItemList/index.js";
import * as Restaumatic_Analytics_Types_NotOverlappingDishesLog from "../Restaumatic.Analytics.Types.NotOverlappingDishesLog/index.js";
import * as Restaumatic_Analytics_Types_PurchaseItem from "../Restaumatic.Analytics.Types.PurchaseItem/index.js";
import * as Restaumatic_Analytics_Types_SetCheckoutOption from "../Restaumatic.Analytics.Types.SetCheckoutOption/index.js";
import * as Restaumatic_Analytics_Types_SuggestionResult from "../Restaumatic.Analytics.Types.SuggestionResult/index.js";
import * as Restaumatic_Analytics_Types_VisitPage from "../Restaumatic.Analytics.Types.VisitPage/index.js";
var encode = /* #__PURE__ */ Foreign_Generic_Class.encode(Restaumatic_Analytics_Types_Item.encodeItem);
var encode1 = /* #__PURE__ */ Foreign_Generic_Class.encode(/* #__PURE__ */ Foreign_Generic_Class.recordEncode()(Foreign_Generic_Class.encodeRecordNil));
var encode2 = /* #__PURE__ */ Foreign_Generic_Class.encode(Restaumatic_Analytics_Types_BeginCheckout.encodeBeginCheckout);
var encode3 = /* #__PURE__ */ Foreign_Generic_Class.encode(Restaumatic_Analytics_Types_PurchaseItem.encodePurchaseItem);
var encode4 = /* #__PURE__ */ Foreign_Generic_Class.encode(Restaumatic_Analytics_Types_SetCheckoutOption.encodeSetCheckoutOption);
var encode5 = /* #__PURE__ */ Foreign_Generic_Class.encode(Restaumatic_Analytics_Types_SuggestionResult.encodeSuggestionResult);
var encode6 = /* #__PURE__ */ Foreign_Generic_Class.encode(Restaumatic_Analytics_Types_ExperienceImpression.encodeExperienceImpression);
var encode7 = /* #__PURE__ */ Foreign_Generic_Class.encode(Restaumatic_Analytics_Types_NotOverlappingDishesLog.encodeNotOverlappingDishesLog);
var encode8 = /* #__PURE__ */ Foreign_Generic_Class.encode(Restaumatic_Analytics_Types_VisitPage.encodeVisitPage);
var encode9 = /* #__PURE__ */ Foreign_Generic_Class.encode(Restaumatic_Analytics_Types_ChooseDelivery.encodeChooseDelivery);
var encode10 = /* #__PURE__ */ Foreign_Generic_Class.encode(Restaumatic_Analytics_Types_ChooseTakeaway.encodeChooseTakeaway);
var encode11 = /* #__PURE__ */ Foreign_Generic_Class.encode(Restaumatic_Analytics_Types_ChooseAddress.encodeChooseAddress);
var encode12 = /* #__PURE__ */ Foreign_Generic_Class.encode(Restaumatic_Analytics_Types_ChooseDineIn.encodeChooseDineIn);
var encode13 = /* #__PURE__ */ Foreign_Generic_Class.encode(Restaumatic_Analytics_Types_ChooseDate.encodeChooseDate);
var encode14 = /* #__PURE__ */ Foreign_Generic_Class.encode(Restaumatic_Analytics_Types_FindAddress.encodeFindAddress);
var toPlatformEvent = function (v) {
    if (v instanceof Restaumatic_Analytics_Types_Event.AddToCart) {
        return {
            name: "AddToCart",
            value: encode(v.value0)
        };
    };
    if (v instanceof Restaumatic_Analytics_Types_Event.LocateMe) {
        return {
            name: "LocateMe",
            value: encode1({})
        };
    };
    if (v instanceof Restaumatic_Analytics_Types_Event.RemoveFromCart) {
        return {
            name: "RemoveFromCart",
            value: encode(v.value0)
        };
    };
    if (v instanceof Restaumatic_Analytics_Types_Event.BeginCheckout) {
        return {
            name: "BeginCheckout",
            value: encode2(v.value0)
        };
    };
    if (v instanceof Restaumatic_Analytics_Types_Event.Purchase) {
        return {
            name: "Purchase",
            value: encode3(v.value0)
        };
    };
    if (v instanceof Restaumatic_Analytics_Types_Event.SetCheckoutOption) {
        return {
            name: "SetCheckoutOption",
            value: encode4(v.value0)
        };
    };
    if (v instanceof Restaumatic_Analytics_Types_Event.SuggestionResult) {
        return {
            name: "SuggestionResult",
            value: encode5(v.value0)
        };
    };
    if (v instanceof Restaumatic_Analytics_Types_Event.ExperienceImpression) {
        return {
            name: "ExperienceImpression",
            value: encode6(v.value0)
        };
    };
    if (v instanceof Restaumatic_Analytics_Types_Event.NotOverlappingDishes) {
        return {
            name: "NotOverlappingDishes",
            value: encode7(v.value0)
        };
    };
    if (v instanceof Restaumatic_Analytics_Types_Event.VisitPage) {
        return {
            name: "VisitPage",
            value: encode8(v.value0)
        };
    };
    if (v instanceof Restaumatic_Analytics_Types_Event.ChooseDelivery) {
        return {
            name: "ChooseDelivery",
            value: encode9(v.value0)
        };
    };
    if (v instanceof Restaumatic_Analytics_Types_Event.ChooseTakeaway) {
        return {
            name: "ChooseTakeaway",
            value: encode10(v.value0)
        };
    };
    if (v instanceof Restaumatic_Analytics_Types_Event.ChooseAddress) {
        return {
            name: "ChooseAddress",
            value: encode11(v.value0)
        };
    };
    if (v instanceof Restaumatic_Analytics_Types_Event.ChooseDineIn) {
        return {
            name: "ChooseDineIn",
            value: encode12(v.value0)
        };
    };
    if (v instanceof Restaumatic_Analytics_Types_Event.ChooseDate) {
        return {
            name: "ChooseDate",
            value: encode13(v.value0)
        };
    };
    if (v instanceof Restaumatic_Analytics_Types_Event.FindAddress) {
        return {
            name: "FindAddress",
            value: encode14(v.value0)
        };
    };
    if (v instanceof Restaumatic_Analytics_Types_Event.ReviewGoogleLinkShown) {
        return {
            name: "ReviewGoogleLinkShown",
            value: encode1({})
        };
    };
    if (v instanceof Restaumatic_Analytics_Types_Event.OrderingImpossibleAlert) {
        return {
            name: "OrderingImpossibleAlert",
            value: encode1({})
        };
    };
    throw new Error("Failed pattern match at Restaumatic.Analytics.Tracking.Event (line 34, column 19 - line 58, column 6): " + [ v.constructor.name ]);
};
var promotionalCategory = "Promotional";
var nonPromotionalCategory = "NonPromotional";
var dailyLunchesCategory = "daily_lunches";
export {
    dailyLunchesCategory,
    nonPromotionalCategory,
    promotionalCategory,
    toPlatformEvent
};
export {
    AddToCart,
    BeginCheckout,
    ChooseAddress,
    ChooseDate,
    ChooseDelivery,
    ChooseDineIn,
    ChooseTakeaway,
    ExperienceImpression,
    FindAddress,
    LocateMe,
    NotOverlappingDishes,
    OrderingImpossibleAlert,
    Purchase,
    RemoveFromCart,
    ReviewGoogleLinkShown,
    SetCheckoutOption,
    SuggestionResult,
    VisitPage
} from "../Restaumatic.Analytics.Types.Event/index.js";
export {
    Item
} from "../Restaumatic.Analytics.Types.Item/index.js";
export {
    CrossSelling,
    LastOrder,
    Menu
} from "../Restaumatic.Analytics.Types.ItemList/index.js";
export {
    PurchaseItem
} from "../Restaumatic.Analytics.Types.PurchaseItem/index.js";
